// WCAG 2 contrast (the same formula as tests/unit/theme.test.ts) and the choice of a text colour that meets a
// target ratio against one or more backgrounds. Used to pick ad text colours from the brand (instantiate.ts).
type RGB = [number, number, number];

const lin = (v: number) => (v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4);
export const luminance = (c: RGB) => 0.2126 * lin(c[0]) + 0.7152 * lin(c[1]) + 0.0722 * lin(c[2]);
export function contrast(a: RGB, b: RGB): number {
  const [x, y] = [luminance(a), luminance(b)].sort((p, q) => q - p);
  return (x! + 0.05) / (y! + 0.05);
}

/** The first candidate that reaches `ratio` against every background; else the one with the best worst case. */
export function pickText(candidates: RGB[], backgrounds: RGB[], ratio: number): RGB {
  const worst = (c: RGB) => Math.min(...backgrounds.map((b) => contrast(c, b)));
  const ok = candidates.find((c) => worst(c) >= ratio);
  if (ok) return ok;
  return candidates.reduce((best, c) => (worst(c) > worst(best) ? c : best));
}

/** WCAG "large text" for an ad seen on a phone: the ad's width is shown at about 390 CSS px. */
export const isLargeText = (size: number, weight: number, adWidth: number) => {
  const css = (size * 390) / adWidth;
  return css >= 24 || (weight >= 700 && css >= 18.66);
};
